export const getLocationPath = (locationPath) => {
    if (!locationPath || !Array.isArray(locationPath)) {
        return null
    }

    return locationPath.join('→')
}